import { cn } from "@/lib/utils";
import { useForYouTheme } from "./forYouTheme";

/** Soft pulse placeholders while För dig listings load. */
export function ForYouFeedSkeleton() {
  const t = useForYouTheme();

  return (
    <div
      className={cn(
        "fixed inset-0 z-[90] flex flex-col",
        t.shell,
      )}
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
      aria-busy
      aria-label="Loading"
    >
      <div
        className="pointer-events-none absolute inset-x-0 top-0 z-40 h-44"
        style={{ background: t.shellFade }}
      />
      <div
        className="absolute inset-x-0 top-0 z-40 flex justify-center gap-8 px-3 pb-3"
        style={{ paddingTop: "calc(env(safe-area-inset-top, 0px) + 0.9rem)" }}
      >
        <div className="h-3.5 w-20 animate-pulse rounded-full bg-white/25" />
        <div className="h-3.5 w-16 animate-pulse rounded-full bg-white/35" />
      </div>

      <div className="relative flex min-h-0 flex-1 flex-col px-0 pt-[calc(env(safe-area-inset-top,0px)+3.25rem)]">
        <div className="relative h-[55%] w-full shrink-0 overflow-hidden">
          <div
            className={cn(
              "h-full w-full animate-pulse",
              t.dark ? "bg-white/10" : "bg-black/10",
            )}
          />
          <div className="absolute inset-x-0 bottom-4 z-10 flex justify-center gap-1.5">
            <div className="h-1.5 w-1.5 animate-pulse rounded-full bg-white/50" />
            <div className="h-1.5 w-1.5 animate-pulse rounded-full bg-white/30" />
            <div className="h-1.5 w-1.5 animate-pulse rounded-full bg-white/30" />
          </div>
        </div>

        <div
          className={cn(
            "flex min-h-0 flex-1 flex-col gap-3 px-4 pt-3",
            t.infoMobile,
          )}
          style={{
            paddingBottom: "calc(env(safe-area-inset-bottom, 0px) + 12px)",
          }}
        >
          <div className="h-7 w-40 animate-pulse rounded-lg bg-foreground/10" />
          <div className="h-4 w-56 animate-pulse rounded-md bg-foreground/10" />
          <div className="mt-1 flex gap-2">
            <div className="h-8 w-20 animate-pulse rounded-full bg-foreground/10" />
            <div className="h-8 w-24 animate-pulse rounded-full bg-foreground/10" />
            <div className="h-8 w-16 animate-pulse rounded-full bg-foreground/10" />
          </div>
          <div className="mt-2 grid grid-cols-3 gap-2">
            <div className="h-12 animate-pulse rounded-xl bg-foreground/10" />
            <div className="h-12 animate-pulse rounded-xl bg-foreground/10" />
            <div className="h-12 animate-pulse rounded-xl bg-foreground/10" />
          </div>
          <div className="mt-auto flex flex-col items-center gap-1.5 pb-1 pt-4">
            <div className="h-3 w-3 animate-pulse rounded-sm bg-foreground/15" />
            <div className="h-3 w-28 animate-pulse rounded-md bg-foreground/10" />
          </div>
        </div>
      </div>
    </div>
  );
}
